export default {
  namespaced: true,
  state: {
    isMobile: false,
    theme: 'dark',
    layout: 'side',
    systemName: '牛框框平台',
    copyright: '蜀ICP备09005532号-11',
    footerLinks: [
      {link: 'https://beian.miit.gov.cn/', name: '蜀ICP备09005532号-11'}
      // {link: '', icon: 'github'},
      // {link: '', name: '智互链'}
    ],
    multipage: false
  },
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      state.theme = theme
    },
    setLayout (state, layout) {
      state.layout = layout
    },
    setMultipage (state, multipage) {
      state.multipage = multipage
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js